import React from 'react';
import { Card } from 'react-bootstrap';
import CookiesSite from '../../utils/CookiesSite';

//Utils
import { getEvento } from '../../utils/eventosessioncred';

//<CookiesSite idpromotora={getEvento().idpromotora} />
const Footer = () => {
    const ano = new Date();
    return (        
        <Card.Footer className="text-center">
            {ano.getFullYear()}@Cidtech            
        </Card.Footer>
    )
}

export default Footer;